// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { PropsWithChildren, useMemo } from 'react';
import useDsoParty from '../hooks/queries/cn/useDsoParty';
import usePrimaryParty from '../hooks/queries/usePrimaryParty';
import { useOperatorParty } from '../hooks/queries/utility-operator/useOperatorParty';
import { PartiesContext } from './PartiesContext';

/**
 * @deprecated use individual party hooks directly where needed -- usePrimaryParty, useDsoParty, useOperatorParty
 */
export const PartiesProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const dso = useDsoParty()?.data || '';
  const party = usePrimaryParty()?.data || '';
  const operator = useOperatorParty()?.data || '';

  const value = useMemo(() => ({ operator, party, dso }), [operator, party, dso]);

  return <PartiesContext.Provider value={value}>{children}</PartiesContext.Provider>;
};
